export default __webpack_public_path__ + "static/media/_DSC0495.ebc145ad.jpg";